import { Clock, Play, BookOpen, TrendingUp, Flame, User, Settings } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface TooltipDefinition {
  id: string;
  anchorId: string;
  title: string;
  body: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
  icon: LucideIcon;
}

export type TooltipPage = 'timer' | 'dashboard' | 'profile';

// Timer Page — Primary guidance for first-time users (ordered top-to-bottom on page)
export const TIMER_TOOLTIPS: TooltipDefinition[] = [
  {
    id: 'session-length',
    anchorId: 'session-selector',
    title: 'Start your first session',
    body: '30-60 minutes works great. You can change this anytime.',
    placement: 'bottom',
    icon: Clock,
  },
  {
    id: 'category',
    anchorId: 'category-selector',
    title: 'Track what you study',
    body: 'Optional: pick a category to see what you spend time on.',
    placement: 'bottom',
    icon: BookOpen,
  },
  {
    id: 'play-button',
    anchorId: 'start-session-button',
    title: 'Ready when you are',
    body: 'Tap play to begin. Distractions fade, focus sharpens.',
    placement: 'top',
    icon: Play,
  },
];

// Dashboard Page — Light reinforcement
export const DASHBOARD_TOOLTIPS: TooltipDefinition[] = [
  {
    id: 'daily-progress',
    anchorId: 'daily-goal-ring',
    title: 'Your daily progress',
    body: 'This fills as you study toward your daily goal.',
    placement: 'bottom',
    icon: TrendingUp,
  },
  {
    id: 'streaks',
    anchorId: 'streak-tracker',
    title: 'Build your momentum',
    body: 'Study consistently to grow your streak. Each day builds on the last.',
    placement: 'top',
    icon: Flame,
  },
];

// Profile Page — Discovery hints
export const PROFILE_TOOLTIPS: TooltipDefinition[] = [
  {
    id: 'avatar-customization',
    anchorId: 'profile-avatar-orb',
    title: 'Make it yours',
    body: 'Tap to customize your avatar and profile.',
    placement: 'right',
    icon: User,
  },
  {
    id: 'settings-access',
    anchorId: 'profile-settings-tab',
    title: 'Adjust your preferences',
    body: 'Change themes, sounds, goals, and more.',
    placement: 'left',
    icon: Settings,
  },
];

// Page to tooltips mapping
export const PAGE_TOOLTIPS: Record<TooltipPage, TooltipDefinition[]> = {
  timer: TIMER_TOOLTIPS,
  dashboard: DASHBOARD_TOOLTIPS,
  profile: PROFILE_TOOLTIPS,
};
